import React, { useState, useEffect } from "react";

const DataTablePaging = (props) => {

	const {
		cntPerPage,	// 한페이지에 표시할 데이터 개수
		pageNo,		// 현재 페이지 번호
		totalCnt,	// 데이터 개수
		viewPageCnt = 10,	// 한번에 표시할 페이지번호 개수
		searchFnc,	// 페이지 클릭시 조회 function
		searchCond,	// 페이지 클릭시 조회 조건
	} = props;

	const [pagingInfo, setPagingInfo] = useState({maxPageNo: 0, viewMinPageNo: 0, viewMaxPageNo: 0, viewPages: [], currPageNo: 0});

	useEffect(() => {
		let maxPageNo = Math.floor(totalCnt / cntPerPage);	// 페이지 개수
		const maxPageNoRemainder = totalCnt % cntPerPage;	// 나머지

		// 나머지가 있으면 페이지개수 +1
		if(maxPageNoRemainder > 0) {
			maxPageNo += 1;
		}

		let currPageNo = Math.min(pageNo, maxPageNo);

		let viewMinPageNo = 1;
		let viewMaxPageNo = viewPageCnt;

		while(currPageNo > viewMaxPageNo) {
			viewMinPageNo += viewPageCnt;
			viewMaxPageNo += viewPageCnt;
		}
		viewMaxPageNo = Math.min(viewMaxPageNo, maxPageNo);

		let viewPages = [];
		for(let i=viewMinPageNo; i<=viewMaxPageNo; i++) {
			viewPages.push(i);
		}

		setPagingInfo({maxPageNo: maxPageNo, viewMinPageNo: viewMinPageNo, viewMaxPageNo: viewMaxPageNo, viewPages: viewPages, currPageNo: currPageNo})
	}, [cntPerPage, pageNo, totalCnt, viewPageCnt]);

	const goPage = (pageNo) => {
		if(pageNo === pagingInfo.currPageNo) return;
		searchFnc({...searchCond, pageNo: pageNo});
	}

	return (
		<div className="data-paging">
			<button onClick={() => goPage(1)} disabled={pagingInfo.viewMinPageNo === 1}>
				{"<<"}
			</button>
			<button onClick={() => goPage(pagingInfo.viewMinPageNo - viewPageCnt)} disabled={pagingInfo.viewMinPageNo === 1}>
				{"<"}
			</button>
			<div className="page-no">
			{pagingInfo.viewPages.map(p => (
				<span key={p} className={p === pagingInfo.currPageNo ? "cur" : ""} onClick={() => goPage(p)}>
					{" "}
					{p}
					{" "}
				</span>
			))}
			</div>
			<button onClick={() => goPage(pagingInfo.viewMinPageNo + viewPageCnt)} disabled={pagingInfo.viewMaxPageNo === pagingInfo.maxPageNo}>
				{">"}
			</button>
			<button onClick={() => goPage(pagingInfo.maxPageNo)} disabled={pagingInfo.viewMaxPageNo === pagingInfo.maxPageNo}>
				{">>"}
			</button>
		</div>
	);

};
export default DataTablePaging;